import React, { useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { Button, Input, Table, Tooltip } from "antd";
import moment from "moment";
import { AuditOutlined } from "@ant-design/icons";
import CommissaryEmployeeLayout from "../../../layout/CommissaryEmployeeLayout";
import { UserInfo } from "../../../../context";
import MyProcessPODetails from "./MyProcessPODetails";

const MyProcessPO = () => {
  const [poList, setPOList] = useState({
    data: [],
    ready: false,
  });
  //   const [loading, setLoading] = useState(false);
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [selectedData, setSelectedData] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [search, setSearch] = useState("");

  const columns = [
    {
      title: "Date Created",
      dataIndex: "created_at",
      sorter: (a, b) => a.created_at - b.created_at,
      render: (date) => (
        <p>{moment(new Date(date), "YYYY-MM-DD").format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Merchant PO Number",
      dataIndex: "po_number",
      sorter: (a, b) => a.po_number - b.po_number,
      render: (text, record) => (
        <p
          style={{
            color: "blue",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Merchant",
      render: (text, record) => <p>{text.posavemerchantinfo.business_name}</p>,
    },
    {
      title: "Status",
      align: "center",
      render: (text, record) => (
        <p>
          {text.po_status === "new"
            ? "P.O Placed"
            : text.po_status === "acknowledge"
            ? "Acknowledged"
            : text.po_status === "preparing"
            ? "Preparing"
            : text.po_status === "ready"
            ? "Ready To Deliver"
            : text.po_status === "in-transit"
            ? "In Transit"
            : text.po_status === "arrived"
            ? "Arrived"
            : "Completed"}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];
  const tableProps = {
    bordered: false,
    // loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getPOList = useCallback(() => {
    var params = {
      commissary_user_id: userData.data.userscomemployee.user_id,
      user_id: userData.data.id,
    };
    axios
      .get("user/commissary-employee/po-list/by-employee-id", { params })
      .then((response) => {
        const data = response.data;
        setPOList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data]);

  useEffect(() => {
    getPOList();
  }, [getPOList]);

  const searchable = poList.data.filter((data) => {
    return (
      data.po_number.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.posavemerchantinfo.business_name
        .toLowerCase()
        .indexOf(search.toLowerCase()) >= 0
    );
  });

  return (
    <CommissaryEmployeeLayout>
      <div style={{ marginBottom: 10 }}>
        <Input
          placeholder="Search P.O # or business name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            border: "2px solid #e5e5e5",
            width: window.innerWidth < 576 ? "100%" : 300,
          }}
          size="large"
        />
      </div>
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.po_number_id}
        />
      </div>

      {openDrawer && (
        <MyProcessPODetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          selectedData={selectedData}
        />
      )}
    </CommissaryEmployeeLayout>
  );
};

export default MyProcessPO;
